import { useEffect, useState } from "react";

export const THEME_KEY = "tc_theme";
export const THEMES = ["light", "dark"];

export const getTheme = () => (THEMES.includes(localStorage.getItem(THEME_KEY)) ? localStorage.getItem(THEME_KEY) : "light");

export const applyTheme = (theme) => {
  const t = THEMES.includes(theme) ? theme : "light";
  document.documentElement.dataset.theme = t;
  document.documentElement.style.colorScheme = t;
  localStorage.setItem(THEME_KEY, t);
  window.dispatchEvent(new CustomEvent("tc:theme", { detail: t }));
};

applyTheme(getTheme());

export const useTheme = () => {
  const [theme, setTheme] = useState(getTheme());
  useEffect(() => {
    const h = (e) => setTheme(e.detail);
    window.addEventListener("tc:theme", h);
    return () => window.removeEventListener("tc:theme", h);
  }, []);
  return theme;
};
